import { render, staticRenderFns } from "./ConfigurarePage.vue?vue&type=template&id=c6f6f6fe&scoped=true"
import script from "./ConfigurarePage.vue?vue&type=script&lang=js"
export * from "./ConfigurarePage.vue?vue&type=script&lang=js"
import style0 from "./ConfigurarePage.vue?vue&type=style&index=0&id=c6f6f6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f6f6fe",
  null
  
)

export default component.exports